import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ConfirmatoryPopupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_white};

  .confirmatory-message {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }
  .confirmatory-message-note-container {
    margin-top: 20px;
    display: flex;
  }

  .note-message {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
    margin-left: 5px;
  }
`;

export const AddNewContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_black1};
  gap: 32px;
  ${responsive.MOBILE`
    gap: 0;
    background-color: ${COLORS.cirrus_white};
  `}
  .content {
    width: 100%;
    padding: 24px 16px;

    ${responsive.MOBILE`
      padding: 16px 16px;
      overflow-x: hidden;
      width: 100%;
      box-sizing: border-box;

    .MuiFormControl-root,
    .MuiTextField-root {
      width: 100%;
      box-sizing: border-box;
    }
  
    `}
  }

  .contact-type-container {
    display: flex;
    flex-direction: row;
  }

  .checkbox-container {
    margin-top: 38.5px;

    ${responsive.MOBILE`
    margin-top: 0px;
    `}
  }
`;
